module.exports = __webpack_public_path__ + "img/adameva03.5f010481.svg";